<template>
    <div class="LeadingTalentwarp">
        <NavMenu :tokenText="tokenText" />
        <img :src="img1" alt="" class="topimgbox" @click="singupFn">
        <div class="typeArae">
            <div class="primaryTitle">
                <span class="left-line"></span>
                <span class="title">项目介绍</span>
                <span class="right-line"></span>
            </div>
            <div class="peojectDataBox">
                <div v-for="(item,index) in projectData" :key="index" class="projectItembox" @click="showFn(item)">
                    <img :src="item.icon" class="iconimgbox" />
                    <div class="name">{{item.name}}</div>
                </div>
            </div>
            <div class="primaryTitle">
                <span class="left-line"></span>
                <span class="title">工作动态</span>
                <span class="right-line"></span>
            </div>
            <div class="datalistBox" v-if='dataList.length!=0'>
                <!-- <div class="leftImgRightTextBox">
                    <div v-for="(item,index) in dataList" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                        <div class="dateBox">
                            <div class="newsday">{{item.pressTime | day}}</div>
                            <div class="newsyearmonth">{{item.pressTime | timer}}</div>
                        </div>
                        <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                        <div class="contentbox">
                            <div class="title overflowone">{{item.pressTopic}}</div>
                            <div class="synopsis overflowthree">{{item.synopsis}}</div>
                        </div>
                    </div>
                </div> -->
                <div class="leftImgRightTextBox">
                    <div v-for="(item,index) in dataList" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                        <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                        <div class="contentbox">
                            <div class="title overflowone">{{item.pressTopic}}</div>
                            <div class="synopsis overflowthree">{{item.synopsis}}</div>
                            <div class="time">{{item.pressTime | timer}}</div>

                        </div>
                    </div>
                </div>
                <div class="pagination-box" style="margin:0">
                    <el-pagination background @size-change="workhandleSizeChange" @current-change="workhandleCurrentChange" :current-page="workcurrentPage"
                        :page-sizes="[5,10]" :page-size="workpageSize" layout="total, sizes, prev, pager, next, jumper" :total="worktotal">
                    </el-pagination>
                </div>
            </div>
            <div class="emptyBox" v-else>
                <img src="@/assets/imgs/home/emptyimg.png" />

            </div>
        </div>
        <div class="primaryTitle">
            <span class="left-line"></span>
            <span class="title">学员展播</span>
            <span class="right-line"></span>
        </div>
        <!-- <img :src="img2" class="imgbox2"> -->
        <div class="studentdataBox" v-if='studentData.length!=0'>
            <div class="databox">
                <!-- <div class="itemwarp" ref="studentItem">  @click="changeStudentFn(index)" -->
                <div class="studentItembox" v-for="(item,index) in studentData" :key="index" @click="goNewsDetailFn(item)">
                    <img class="headimg" :src="srcUrl+item.titleImgUrl" />
                    <div class="contentbox">
                        <div class="name overflowone">{{item.pressTopic}}</div>
                        <div class="synopsis overflowtwo">{{item.synopsis}}</div>
                        <div class="time">{{item.pressTime | timer}}</div>
                    </div>
                </div>
                <!-- </div> -->
            </div>
            <div class="pagination-box" style="marginTop:50px;color:#fff;">
                <el-pagination background @size-change="studenthandleSizeChange" @current-change="studenthandleCurrentChange" :current-page="studentcurrentPage"
                    :page-sizes="[3]" :page-size="studentpageSize" layout="prev, pager, next" :total="studenttotal">
                </el-pagination>
            </div>

        </div>
        <div class="emptyBox" v-else>
            <img src="@/assets/imgs/home/emptyimg.png" />
        </div>
        <div class="primaryTitle">
            <span class="left-line"></span>
            <span class="title">班级风采</span>
            <span class="right-line"></span>
        </div>
        <div class="ClassBox">
            <ClassStyle/>
        </div>
        <Footer/>
        <!-- 领军人才项目介绍弹框 -->
        <el-dialog :title="leadTitle" :visible.sync="newsVisible" width="1000px" class="dialogWarp" :destroy-on-close="true" :append-to-body="true"
            :close-on-click-modal='false' :show-close='false'>
            <div class="singupdialogcenter">
                <div v-html="leadNewsObj"></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeNewsFn">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 证书查询 -->
        <el-dialog title="证书查询" :visible.sync="infoVisible" width="1200px" class="dialogWarp" @closed="offinfoFn" :destroy-on-close="true"
            :close-on-click-modal='false' :append-to-body="true">
            <div class="singupdialogcenter">
                <!-- <div class="text">信息查询</div> -->
                <el-form :model="ruleForm" ref="infoForm" :rules="inforules">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="姓名:" prop="names" label-width="60px">
                                <el-input v-model="ruleForm.names"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="身份证号码:" prop="cardCode" label-width="120px">
                                <el-input v-model="ruleForm.cardCode"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <div class="submintBtn" @click="submitinfoForm('infoForm')">立即查询</div>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="datawarp">
                    <div class="searchbox">
                        <!-- <div v-for="(item,index) in dialogList" :key="index" :class="dialogcurrentSearch==item.name?'activesearchItem':'searchItem'"
                            @click="dialogSearchFn(item)">
                            {{item.name}}
                        </div> -->
                    </div>
                    <div v-if="infoDataList.length!=0">
                        <div class="datalistBox" v-if="dialogcurrentSearch=='报名信息'">
                            <div class="trainItem" v-for="(item,index) in infoDataList" :key="index">
                                <div class="name overflowone">{{item.trainCourse}}</div>
                                <div class="courseinfobox">
                                    <div>课程编码：
                                        <span>{{item.trainCode}}</span>
                                    </div>
                                    <!-- <div>课程起止时间：
                                    <span>{{item.startTime}}至{{item.endTime}}</span>
                                </div> -->
                                    <!-- <div>课程地点：
                                    <span>{{item.trainSite}}</span>
                                </div> -->
                                    <div>培训费用：
                                        <span>{{item.pay}}</span>
                                    </div>
                                    <div>招报人数：
                                        <span>{{item.playNumber}}</span>
                                    </div>
                                    <div>报名截止：
                                        <span class="deadlinebox">{{item.deadline}}</span>
                                    </div>
                                </div>

                                <div class="registeredbox">
                                    已报名
                                </div>
                            </div>
                        </div>
                        <div class="pdfdatabox" v-else>
                            <div class="pdfItem" v-for="(item,index) in infoDataList" :key="index">
                                <div class="pdftop">
                                    <div v-if="item.certificateName">{{item.certificateName}}</div>
                                    <div v-if="item.certificateCode">{{item.certificateCode}}</div>
                                </div>
                                <div class="pdfbotbox">
                                    <div class="downbox" v-if="item.certificateUrl" @click="downloadFn(item.certificateUrl)">
                                        <img src="@/assets/imgs/train/bgimg2.png" />
                                        <span class="downicon">
                                            <i class="el-icon-download icon" />
                                        </span>
                                    </div>
                                    <div class="courseinfobox">
                                        <div class="name overflowone">{{item.trainCourse}}</div>
                                        <div class="infotext">姓名：
                                            <span>{{ruleForm.names}}</span>
                                        </div>
                                        <div class="infotext">身份证号码：
                                            <span>{{ruleForm.cardCode}}</span>
                                        </div>
                                        <div class="infotext ">成绩：
                                            <!-- <span class="score">{{item.score}}</span> -->
                                            <span v-if="item.certificateUrl" class="score">{{item.score?item.score:'合格'}}</span>
                                            <span class="score" v-else>{{item.score}}</span>
                                        </div>
                                        <div class="infotext" v-if="item.certificateUrl">发证时间：
                                            <span class="deadlinebox">{{item.creationTime | timers}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pagination-box">
                            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                                :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                            </el-pagination>
                        </div>
                    </div>
                    <div v-else class="searchempty">
                        <img src="@/assets/imgs/train/img2.png" class="imgbox1" v-if="!ruleForm.cardCode" />
                        <img src="@/assets/imgs/train/img1.png" class="imgbox2" v-else />
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="primary" @click="gologin">好的</el-button> -->
                <el-button @click="offinfoFn">关闭</el-button>
            </span>
        </el-dialog>
        <!-- 预审 -->
        <!-- <div v-if="singupVisible"> -->
        <LeadSingupModal v-if="step==1" @changeShowFirst='changeShowFirst' />
        <!-- </div> -->
        <!-- 注册 -->
        <LeadRegistModal v-if="step==2" :firstFormData='firstFormData' @changeShowRegist='changeShowRegist' />
        <!-- 第二步 -->
        <LeadSecondModal v-if="step==3" :leartrainData='leartrainData' @changeShowSecond='changeShowSecond' />
        <!-- 上传文件 -->
        <LeadFileModal v-if="step==4" @changeShowFile='changeShowFile' />
        <!-- 开票信息 -->
        <LeadBillModal v-if="step==5" @changeShowBill='changeShowBill' :leartrainData='leartrainData' />

    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import ClassStyle from './ClassStyle/index'
import LeadSingupModal from './LeadSingupModal'
import LeadRegistModal from './LeadRegistModal'
import LeadFileupModal from './LeadFileupModal'
import LeadSecondModal from './LeadSecondModal'
import LeadFileModal from './LeadFileModal'
import LeadBillModal from './LeadBillModal'
import { httpService, srcUrl, videoUrl } from "@/service/httpService";
// import { nextTick } from 'q';
export default {
    components: {
        NavMenu,
        Footer,
        ClassStyle,
        LeadSingupModal,
        LeadFileupModal,
        LeadRegistModal,
        LeadSecondModal,
        LeadFileModal,
        LeadBillModal
    },
    data() {
        return {
            srcUrl: srcUrl,
            img1: require("@/assets/imgs/lead/img1.png"),
            img2: require("@/assets/imgs/lead/img2.png"),
            projectData: [
                // icon: require("@/assets/imgs/nav/loginicon.png"), 
                { name: '研修背景', icon: require("@/assets/imgs/lead/icon1.png") },
                { name: '研修目标', icon: require("@/assets/imgs/lead/icon2.png") },
                { name: '研修对象', icon: require("@/assets/imgs/lead/icon3.png") },
                { name: '研修内容', icon: require("@/assets/imgs/lead/icon4.png") },
                { name: '证书授予', icon: require("@/assets/imgs/lead/icon5.png") },
                { name: '研修费用', icon: require("@/assets/imgs/lead/icon6.png") },
                { name: '证书查询', icon: require("@/assets/imgs/lead/icon7.png") },
            ],
            dataList: [],
            workcurrentPage: 1,
            workpageSize: 5,
            worktotal: null,
            step: 0,            // singupVisible: false,
            // 注册
            registVisible: false,
            // 完善資料
            secondVisible: false,
            studentIndex: -1,
            studentData: [],
            studentcurrentPage: 1,
            studentpageSize: 3,
            studenttotal: null,
            islogin: sessionStorage.getItem('token'),
            leartrainData: null,
            // 弹框
            fileVisible: false,
            status: '',//报名状态
            leadNewsObj: null,
            newsVisible: false,
            // 证书查询
            infoVisible: false,
            dialogList: [
                { name: '报名信息' },
                { name: '成绩证书' },
            ],
            dialogcurrentSearch: '成绩证书',
            currentPage: 1,
            pageSize: 10,
            total: null,
            ruleForm: {
                names: '',
                cardCode: '',
            },
            inforules: {
                names: [
                    { required: true, message: '姓名', trigger: 'blur' },
                ],
                cardCode: [
                    { required: true, message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
                ],
            },
            infoDataList: [],
            leadTitle: '',
            firstFormData: null,
            firstShow: 0,
            source: null,
            tokenText: "",
        }
    },
    created() {
        // 学员展播
        this.getstudyData()
        // 工作动态
        this.getworkData()
        this.source = this.$route.query.source
        // 获取领军人才课程信息
        this.getlearInfo()
    },
    methods: {
        async getlearInfo() {
            httpService.getLeaderClass().then(res => {
                if (res.code == 200) {
                    this.leartrainData = res.result
                    this.status = res.result.status
                    if (this.source == 'account') {
                        this.singupFn()
                    }
                } else {
                    this.$message.error(res.message);
                }
            })
        },

        goNewsDetailFn(val) {
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        },
        showFn(val) {
            if (val.name == '研修背景') {
                this.leadDedailFn(431)
            } else if (val.name == '研修目标') {
                this.leadDedailFn(433)
            } else if (val.name == '研修对象') {
                this.leadDedailFn(434)
            } else if (val.name == '研修内容') {
                this.leadDedailFn(432)
            } else if (val.name == '证书授予') {
                this.leadDedailFn(435)
            } else if (val.name == '研修费用') {
                this.leadDedailFn(436)
            } else if (val.name == '证书查询') {
                this.infoVisible = true
                this.stopScroll()
            }
            this.leadTitle = val.name
        },
        async leadDedailFn(val) {
            let data = await httpService.getNewsDetails(val);
            if (data.code == 200) {
                this.leadNewsObj = data.result.content
                this.newsVisible = true
                this.stopScroll()
            }
        },
        closeNewsFn() {
            this.newsVisible = false
            this.canScroll()
        },
        // 证书查询
        dialogSearchFn(item) {
            this.dialogcurrentSearch = item.name
            let params = {
                pageCurrent: this.currentPage,
                pageSize: this.pageSize,
                ...this.ruleForm
            }
            if (this.dialogcurrentSearch == '报名信息') {
                httpService.findApply(params).then(res => {
                    if (res.code == 200) {
                        this.infoDataList = res.result.list
                        this.total = res.result.total
                    } else {
                        this.$message.error(res.message);
                    }
                })
            } else {
                httpService.findGrade(params).then(res => {
                    if (res.code == 200) {
                        this.infoDataList = res.result.list
                        this.total = res.result.total
                    } else {
                        this.$message.error(res.message);
                    }
                })
            }
        },
        // // 报名信息
        // searchApplyFn() {
        //     let params = {
        //         pageCurrent: this.pageCurrent,
        //         pageSize: this.pageSize,
        //         ...this.ruleForm
        //     }
        // },
        // 查询
        submitinfoForm(formName) {
            // this.infoVisible = true
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        pageCurrent: this.currentPage,
                        pageSize: this.pageSize,
                        ...this.ruleForm
                    }
                    if (this.currentSearch == '报名信息查询') {
                        httpService.findApply(params).then(res => {
                            if (res.code == 200) {
                                this.infoDataList = res.result.list
                                this.total = res.result.total
                                this.infoVisible = true
                                this.stopScroll()
                            }
                        })
                    } else {
                        this.dialogcurrentSearch = '成绩证书'
                        httpService.findGrade(params).then(res => {
                            if (res.code == 200) {
                                this.infoDataList = res.result.list
                                this.total = res.result.total
                                this.infoVisible = true
                                this.stopScroll()
                            }
                        })
                    }
                } else {
                    return false;
                }
            });
        },
        // 关闭查询弹框
        // 关闭表单
        offinfoFn() {
            this.infoVisible = false
            this.canScroll()
            this.ruleForm = {
                names: '',
                cardCode: '',
            }
            this.infoDataList = []
            this.dialogcurrentSearch = '报名信息'
        },
        // 信息查询分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.dialogSearchFn(this.dialogcurrentSearch);
        },
        handleCurrentChange(val) {
            // this.pageSize = 1;
            this.currentPage = val;
            this.dialogSearchFn(this.dialogcurrentSearch);
        },

        singupFn() {
            // this.getlearInfo()
            if (this.leartrainData) {
                let auditResultStatus = this.leartrainData.auditResultStatus
                if (!this.islogin) {
                    this.step = 1
                    this.stopScroll()
                } else {
                    if (auditResultStatus) {
                        switch (auditResultStatus) {
                            case '1':
                                // this.$message({
                                //     message: '预审报名审核中，审核结果请移至【账户中心】下的【消息通知】进行查看',
                                //     type: 'warning'
                                // });
                                this.step = 3
                                this.stopScroll()
                                break;
                            case '2':
                                if (this.leartrainData.billAudit == 1) {
                                    this.$message({
                                        message: '领军人才课程待缴费，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
                                        type: 'warning'
                                    });
                                    return
                                } else {
                                    this.step = 5
                                }
                                this.stopScroll()
                                break;
                            case '3':
                                //  上传文件审核失败
                                // this.fileVisible = true
                                this.step = 4
                                this.stopScroll()
                                break;
                            case '4':
                                this.$message({
                                    message: '领军人才课程报名已完成，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
                                    type: 'warning'
                                });
                                break;
                            case '5':
                                this.$message({
                                    message: '领军人才课程已生成班级，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
                                    type: 'warning'
                                });
                                break;
                            case '6':
                                this.$message({
                                    message: '领军人才课程培训已完成，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
                                    type: 'warning'
                                });
                                break;
                            case '0':
                                //  保存草稿
                                // this.secondVisible = true
                                this.step = 3
                                this.stopScroll()
                                break;
                            case '98':
                                //  填写详情信息
                                // this.secondVisible = true
                                this.step = 3
                                this.stopScroll()
                                break;
                            case '99':
                                this.$message({
                                    message: '信息审核中，审核结果请移至【账户中心】下的【消息通知】进行查看',
                                    type: 'warning'
                                });
                                break;
                            case '100':
                                //  上传文件
                                // this.fileVisible = true
                                this.step = 4
                                this.stopScroll()
                                break;
                            case '101':
                                if (this.leartrainData.billAudit == 1) {
                                    this.$message({
                                        message: '文件审核中，审核结果请移至【账户中心】下的【消息通知】进行查看',
                                        type: 'warning'
                                    });
                                    return
                                } else {
                                    this.step = 5
                                }
                                this.stopScroll()
                                break;
                            case '198':
                                // this.singupVisible = true
                                this.step = 1
                                this.stopScroll()
                                //  预审审核失败，重回第一步
                                break;
                            case '199':
                                // this.secondVisible = true
                                this.step = 3
                                this.stopScroll()
                                //  详细信息审核失败，重回第二步
                                break;
                            default:
                                break;
                        }
                    } else {
                        this.step = 1
                        this.stopScroll()
                    }
                }
            } else {
                this.getlearInfo()
            }
            // auditResultStatus 0、报存草稿1：提交 2：审核通过3：审核失败4.已缴费,
            // 5，加入班级，6成绩录入，98后台初审通过，99第二次提交，100第二次审核通过，101第三次提交，198初步审核失败，199第二步审核失败）
            // 判断是否能继续报名
            // if (!this.leartrainData.flag) {
            //     this.$message({
            //         message: '领军人才课程报名已完成，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
            //         type: 'warning'
            //     });
            // }
            // else {

            // }
            // if (!this.islogin) {
            //     this.$message({
            //         message: '请先登录网站',
            //         type: 'warning'
            //     });
            // } else {
            // 1提交 2审核通过 3审核失败
            // 現在判断是否能继续报名的状态还没有返回，auditResult是错误的
            // if (this.leartrainData.flag) {
            //     this.singupVisible = true
            //     if (this.leartrainData.auditStatus == 2) {

            //     }
            // }
            //  else {
            //     this.$message({
            //         message: '您已报名成功，请等待审核，报名信息请移至【账户中心】下的【培训课程管理】进行查看',
            //         type: 'warning'
            //     });
            // }
            //  this.singupVisible = true
            // }
        },
        changeStudentFn(index) {
            let itemBox = this.$refs.studentItem;
            let number = itemBox.style.transform
                ? itemBox.style.transform.split("(")[1].split("p")[0] * 1
                : 0;
            // 向右
            if (index > this.studentIndex) {
                if (this.studentData.length - index <= 1) {
                    itemBox.style.transform = `translateX(${-300 + number}px)`;
                    this.studentIndex = index
                    return false
                } else {
                    itemBox.style.transform = `translateX(${-417 + number}px)`;
                    this.studentIndex = index
                }
            } else {
                if (index <= 1) {
                    return false
                } else {
                    itemBox.style.transform = `translateX(${417 + number}px)`;
                    this.studentIndex = index
                }
            }
        },
        // 学员展播
        async getstudyData() {
            let params = {
                pageSize: this.studentpageSize,
                pageCurrent: this.studentcurrentPage,
                pressSuperClass: 33,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {

                this.studentData = data.result.list
                this.studenttotal = data.result.total
            }
        },
        // 工作动态
        async getworkData() {
            let params = {
                pageSize: this.workpageSize,
                pageCurrent: this.workcurrentPage,
                pressSuperClass: 32,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.dataList = data.result.list
                this.worktotal = data.result.total
            }
        },
        changeShowFirst(data, data1, data2) {
            // data1有用户，data2注册需要的数据
            if (data == '关闭') {
                this.step = 0
                this.canScroll()
            } else {
                // 用户已登录
                if (!data) {
                    this.step = 0
                    this.canScroll()
                    if (!data1) {
                        this.step = 2
                        this.stopScroll()
                    } else {
                        if (!this.islogin) {
                            httpService.loginFn(data2).then(res => {
                                if (res.code == 200) {
                                    let data = res.result
                                    sessionStorage.setItem('clickMenu', '培训服务')
                                    sessionStorage.setItem('token', data.token)
                                    sessionStorage.setItem('userInfo', JSON.stringify(data.principal.loginVo))
                                    this.islogin = data.token
                                    this.step = 3
                                    this.canScroll()
                                    this.tokenText = data.token
                                    // this.$nextTick(() => {
                                    //     // console.log('是否进入');
                                    //     // this.singupVisible = false
                                    //     this.$router.push('/leade-talent');
                                    //     this.$router.go(0)
                                    //     // 登录之后直接完善信息
                                    // })
                                } else {
                                    this.$message.error(res.message);
                                }
                            });
                        }
                        // 当用户登录之后提交第一步就可以再次提交第二步
                        else {
                            this.step = 3
                            this.stopScroll()
                        }
                    }
                }
            }
            if (data2) {
                this.firstFormData = data2
            }
            if (this.source == 'account') {
                this.$router.push({ query: {} });
                this.source = null
            }
            this.getlearInfo()
        },
        changeShowRegist(data, data2) {
            if (!data) {
                this.step = 0
                this.canScroll()
                if (data2) {
                    httpService.loginFn(data2).then(res => {
                        if (res.code == 200) {
                            let data = res.result
                            sessionStorage.setItem('clickMenu', '培训服务')
                            sessionStorage.setItem('token', data.token)
                            sessionStorage.setItem('userInfo', JSON.stringify(data.principal.loginVo))
                            this.islogin = data.token
                            this.step = 3
                            this.canScroll()
                            this.tokenText = data.token
                            this.$nextTick(() => {
                                // 用户未注册未登录 注册登录后直接进行第二步
                                // this.step = 0
                                // this.$router.push('/leade-talent');
                                // this.$router.go(0)
                            })
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            }
            this.getlearInfo()
        },
        // 完善信息
        changeShowSecond(data) {
            if (!data) {
                this.step = 0
                this.canScroll()
            }
            if (this.source == 'account') {
                this.$router.push({ query: {} });
                this.source = null
            }
            this.getlearInfo()
        },
        // 上传文件
        changeShowFile(data) {
            if (!data) {
                this.step = 0
                this.canScroll()
            }
            if (this.source == 'account') {
                this.$router.push({ query: {} });
                this.source = null
            }
            this.getlearInfo()
        },
        // 开票信息
        changeShowBill(data) {
            if (!data) {
                this.step = 0
                this.canScroll()
            }
            if (this.source == 'account') {
                this.$router.push({ query: {} });
                this.source = null
            }
            this.getlearInfo()
        },
        // 工作动态
        workhandleSizeChange(val) {
            this.workpageSize = val;
            this.workcurrentPage = 1;
            this.getworkData();
        },
        workhandleCurrentChange(val) {
            this.workcurrentPage = val;
            this.getworkData();
        },
        studenthandleSizeChange(val) {
            this.studentpageSize = val;
            this.studentcurrentPage = 1;
            this.getstudyData();
        },
        studenthandleCurrentChange(val) {
            this.studentcurrentPage = val;
            this.getstudyData();
        },

    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
        // day: (value) => {
        //     return value.substring(8, 10);
        // },
        timers: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.LeadingTalentwarp {
  width: 100%;
  margin: 0 auto;
  .topimgbox {
    width: 100%;
    // height: 405px;
    cursor: pointer;
  }
  .peojectDataBox {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    .projectItembox {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin-right: 40px;
      cursor: pointer;
      &:last-child {
        margin-right: 0px;
      }
      .iconimgbox {
        width: 137px;
        height: 119px;
        // background: red;
        margin-bottom: 12px;
      }
      .name {
        font-size: 22px;
        line-height: 35px;
        color: #333333;
      }
    }
  }
  .datalistBox {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    .leftImgRightTextBox {
      .itemBox {
        margin: 0 0 40px 0;
        width: 1200px;
        cursor: pointer;
        .dateBox {
          width: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .imgbox {
          width: 284px;
          height: 158px;
        }
        .contentbox {
          width: 77%;
          .time {
            margin-top: 0;
          }
        }
      }
    }
  }
  // // .imgbox2{
  //     width: 1903px;
  //     height: 520px;
  // }
  .studentdataBox {
    background: url(../assets/imgs/lead/img2.png) #fff no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    width: 100%;
    height: 570px;
    /deep/.el-pagination__jump {
      color: #fff;
    }
    /deep/.el-pagination__total {
      color: #fff;
    }
    .databox {
      width: 1200px;
      // margin: 0px 240px auto 345px;
      margin: 0 auto;
      padding: 54px 0 0 0;
      box-sizing: border-box;
      // overflow: hidden;
      display: flex;
      flex-direction: row;
      .itemwarp {
        // width: 4170px;
        // transition: all 0.8s;
        // display: flex;
        // flex-direction: row;
        // align-items: center;
      }
      .studentItembox {
        width: 380px;
        height: 385px;
        background: #fff;
        box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.08);
        display: flex;
        flex-direction: column;
        // justify-content: center;
        // align-items: center;
        margin-right: 30px;
        cursor: pointer;
        box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        &:nth-child(3n) {
          margin-right: 0px;
        }
        .headimg {
          width: 100%;
          height: 215px;
          border-radius: 8px 8px 0 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .contentbox {
          padding: 20px 26px 0 20px;
          box-sizing: border-box;
        }
        .name {
          font-size: 18px;
          font-weight: bold;
          line-height: 28px;
          color: #333333;
          padding-bottom: 12px;
          border-bottom: 1px solid #e6e6e6;
          &:hover {
            color: #448df7;
          }
        }
        .company {
          font-size: 18px;
          line-height: 30px;
          color: #666666;
        }
        .synopsis {
          font-size: 16px;
          line-height: 30px;
          color: #666666;
          box-sizing: border-box;
          margin-top: 12px;
        }
        .time {
          font-size: 14px;
          line-height: 36px;
          color: #999999;
        }
      }
    }
  }
  .ClassBox {
    width: 1200px;
    margin: 0 auto 50px auto;
  }
}
.dialogWarp {
  /deep/.singupdialogcenter {
    padding: 17px 60px 0px 60px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .textbox {
      text-align: left;
      font-size: 16px;
      line-height: 21px;
      color: #333333;
      cursor: pointer;
      span,
      .iconbox {
        color: #448df7;
        cursor: pointer;
      }
      .iconbox {
        margin-left: 4px;
      }
    }
    .submintBtn {
      width: 152px;
      height: 40px;
      background: #448df7;
      color: #fff;
      margin: 0 20px;
      cursor: pointer;
      font-size: 16px;
      text-align: center;
      line-height: 40px;
    }
    .datawarp {
      width: 100%;
      border-top: 1px solid #e8e8e8;
      .searchbox {
        display: flex;
        flex-direction: row;
        justify-content: center;
        font-size: 20px;
        line-height: 28px;
        margin: 20px 0 48px 0;
        .searchItem {
          color: #333333;
          cursor: pointer;
          margin: 0 30px;
        }
        .activesearchItem {
          cursor: pointer;
          color: #448df7;
          margin: 0 30px;
        }
      }
      .datalistBox {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 0 90px;
        .trainItem {
          margin: 0 28px 30px 0;
          width: 324px;
          height: 240px;
          box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
          // background: url(../assets/imgs/tarin/bgimg1.png) no-repeat 100%;
          background: url(../assets/imgs/train/bgimg1.png) no-repeat 100% 100%;
          padding: 20px 30px 0 25px;
          box-sizing: border-box;
          &:nth-child(3n) {
            margin-right: 0;
          }
          .name {
            font-size: 16px;
            font-weight: bold;
            line-height: 24px;
            color: #448df7;
            position: relative;
            cursor: pointer;
            margin-bottom: 15px;
          }
          // .name::before {
          // 	content: '';
          // 	position: absolute;
          // 	width: 68px;
          // 	height: 0px;
          // 	border: 2px solid #448df7;
          // 	opacity: 1;
          // 	background: #448df7;
          // 	left: 0%;
          // 	// transform: translateX(-50%);
          // 	top: 32px;
          // }
          .courseinfobox {
            font-size: 14px;
            line-height: 30px;
            color: #666666;
            margin-bottom: 15px;
          }
          .deadlinebox {
            color: #c0c0c0;
          }
          .immediatelyBtn,
          .coursdeadline,
          .registeredbox {
            width: 118px;
            height: 31px;
            line-height: 31px;
            color: #fff;
            margin: 0 auto;
            text-align: center;
          }
          .immediatelyBtn {
            background: #448df7;
            cursor: pointer;
          }
          .coursdeadline {
            background: #c0c0c0;
          }
          .registeredbox {
            background: #4ab344;
          }
        }
      }
      .pdfdatabox {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .pdfItem {
          width: 500px;
          height: 244px;
          background: #fff;
          box-shadow: 0px 3px 22px rgba(204, 213, 220, 0.76);
          border-radius: 12px;
          margin: 0 30px 30px 0px;
          padding: 16px;
          box-sizing: border-box;
          &:nth-child(3n) {
            margin-right: 0;
          }
          .pdftop {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;
            line-height: 24px;
            color: #333333;
            margin-bottom: 20px;
            .certificateName {
              margin-right: 20px;
            }
          }
          .pdfbotbox {
            display: flex;
            flex-direction: row;
            .downbox {
              width: 106px;
              height: 141px;
              background: rgba(94, 206, 255, 0.39);
              position: relative;
              cursor: pointer;
              img {
                width: 64px;
                height: 80px;
                margin: 30px 20px 0 20px;
              }
              .downicon {
                position: absolute;
                bottom: 0px;
                left: 0px;
                font-size: 20px;
                color: #fff;
                width: 0;
                height: 0;
                border-bottom: 50px solid #8f8f8f;
                border-right: 50px solid transparent;
                cursor: pointer;
                .icon {
                  margin: 27px 0px 0px 4px;
                }
              }
            }
            .courseinfobox {
              margin-left: 16px;
              width: 260px;
              .name {
                font-size: 16px;
                font-weight: bold;
                line-height: 24px;
                color: #333333;
              }
              .infotext {
                font-size: 14px;
                line-height: 30px;
                color: #8f8f8f;
              }
              .score {
                font-size: 18px;
                line-height: 24px;
                color: #0e83fc;
              }
            }
          }
        }
      }
      .searchempty {
        width: 100%;
        text-align: center;
        .imgbox1 {
          width: 193px;
          height: 155px;
        }
        .imgbox2 {
          width: 192px;
          height: 160px;
        }
      }
    }
    .singupForm {
      width: 100%;
      /deep/.el-upload--picture-card {
        width: 100px;
        height: 100px;
        line-height: 100px;
      }
      /deep/.el-form-item__label {
        padding: 0;
      }
      /deep/.el-form-item {
        margin-bottom: 10px;
      }
      /deep/.el-upload-list--picture-card .el-upload-list__item {
        width: 100px;
        height: 100px;
      }
      .formBtnBox {
        display: flex;
        fill-opacity: row;
        justify-content: center;
        .submitBtn {
          width: 152px;
          height: 40px;
          background: #349cff;
          margin: 0 20px;
        }

        .cancelBtn {
          width: 152px;
          height: 40px;
          border: 1px solid #a6a9b7;
          border-radius: 5px;
          margin: 0 20px;
        }
      }
      .upicon {
        font-size: 48px;
      }
      .videobox {
        width: 200px;
        height: 200px;
        display: flex;
        flex-direction: row;
        align-content: center;
        // position: relative;
        video {
          object-fit: fill;
        }
        .spanbox {
          // position: absolute;
          // top: 100px;
          // left: 50%;
          // transform: translateX(-50%);
          // width: 50px;
          // height: 50px;
          // text-align: center;
          // line-height: 50px;
          // border-radius: 50%;
          // background: rgb(238, 237, 237);
          margin-left: 10px;
          .videoicon {
            font-size: 20px;
            cursor: pointer;
          }
          &:hover {
            // background: rgb(179, 220, 247);
            color: #349cff;
          }
        }
      }
      .videoFormItem {
        /deep/.el-form-item__content {
          position: relative;
        }
        .videoText {
          position: absolute;
          top: -40px;
          left: 100px;
          cursor: pointer;
          font-size: 14px;
          color: #ff8916;
        }
      }
    }
  }
  .pagination-box {
    margin: 0;
  }
}
</style>


